import axios from "axios"

export const getRegions = function () {
  const controller = new AbortController();

  // const CancelToken = axios.CancelToken;
  // const source = CancelToken.source();
  // controller.abort();
  const response = axios({
    method: "GET",
    url: "/users/getRegion"
  }).then((response) => {
    if (response.data.status === "success") {
      return { success: true, list: response.data.data }
    } else {
      return { success: false, message: response.data.message }
    }
  });
  return response;
}

export const getState = function (formData) {

  const response = axios({
    method: "get",
    data: formData,
    url: "states/all"
  }).then((response) => {
    return response.data
  });
  return response;
}

export const getCityByState = function (stateId = "") {
  let url = `/cities/all/${stateId}`
  const response = axios({
    method: "GET",
    url: url
  }).then((response) => {
    return response.data
  })
  return response;
}

export const getInventoryInitialData = function (inventoryId) {
  let url = "/inventories/initial-data"
  if (inventoryId) {
    url = `/inventories/initial-data?inventoryId=${inventoryId}`
  }
  const response = axios({
    method: "GET",
    url: url,
  }).then((response) => {
    if (response.data.success) {
      return { success: true, list: response.data.data }
    } else {
      return { success: false, message: response.data.message }
    }
  });

  return response;
}

export const getCurrencyList = function (inventoryId) {
  let url = "/vendors/getCurrency"
  // if(inventoryId){
  //       url = `/inventories/initial-data?inventoryId=${inventoryId}`
  // }
  const response = axios({
    method: "GET",
    url: url,
  }).then((response) => {
    if (response.data.status === "success") {
      console.log(response.data)
      return { success: true, list: response.data.data }
    } else {
      return { success: false, message: response.data.message }
    }
  });

  return response;
}

export const getCategories = function (queryStr) {
  let qStr = Object.keys(queryStr).map(key => key + '=' + queryStr[key]).join('&');
  let url = queryStr.brandId ? `/products/categoryList?brandId=${queryStr.brandId}` : "/products/categories/all?" + qStr
  // if(inventoryId){
  //       url = `/inventories/initial-data?inventoryId=${inventoryId}`
  // }
  const response = axios({
    method: "GET",
    url: url,
  }).then((response) => {
    return response.data
  });
  return response;
}

export const getCityPincode = function (cityId, extraQueryStr = {}) {
  // json to query string
  let queryStr = Object.keys(extraQueryStr).map(key => key + '=' + extraQueryStr[key]).join('&');
  let url = `/cities/pincodes/${cityId}?${queryStr}`
  const response = axios({
    method: "GET",
    url: url
  }).then((response) => {
    return response.data
  })
  return response;
}

export const getBrand = function () {
  // json to query string
  let url = `/brand`
  const response = axios({
    method: "GET",
    url: url
  }).then((response) => {
    return response.data
  })
  return response;
}

export const getSubCategories = function ({ catId }) {
  const params = catId ? "?categoryId=" + catId : ''
  let url = `/products/subCategoryList${params}`
  console.log(url)
  const response = axios({
    method: "GET",
    url: url,
  }).then((response) => {
    return response.data
  });
  return response;
}

export const localCurrencyFormater = function (amount = 0) {

  let formatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR'
  });
  return formatter.format(amount);
}